import ThumbnailMediaItem from 'components/Content/Happening/HappeningEDP/EDPInfo/EDPMedia/EDPMediaCarousel/ThumbnailMediaItem/ThumbnailMediaItem';

export default ThumbnailMediaItem;
